import { theme } from '@garnish/constants';

export const MARKER_SIZE = 48;
export const MARKER_ICON_SIZE = MARKER_SIZE / 2;

export const DEFAULT_EDGE_PADDING = theme.spacing['10'];
